import React from 'react';
import styled from 'styled-components';
import { theme } from '../theme';

const Bar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 26px 100px;
  @media (max-width: 700px) {
    padding: 20px 24px;
    flex-direction: column;
    gap: 10px;
  }
`;
const Copyright = styled.div`
  font-family: ${theme.fontMono};
  font-size: 12px;
  color: ${theme.textDim};
`;
const Links = styled.div`
  display: flex;
  gap: 20px;
  font-family: ${theme.fontMono};
  font-size: 12px;
  color: ${theme.textMuted};
`;

export default function Footer() {
  return (
    <Bar>
      <Copyright>&copy; {new Date().getFullYear()} Zaheer Roberts</Copyright>
      <Links>
        <a href="https://github.com/Zeus540" target="_blank" rel="noopener noreferrer">GitHub</a>
        <a href="https://www.linkedin.com/in/zaheerroberts/" target="_blank" rel="noopener noreferrer">LinkedIn</a>
      </Links>
    </Bar>
  );
}
